import AxiosInstance from "../instance";

const getTextSimilarityResult = async (text1: string, text2: string) => {
    const response = await AxiosInstance.getInstance().post("/groupapi/text-similarity", {
        text1,
        text2
    });

    return response;
};

export {getTextSimilarityResult};


// WEBPACK FOOTER //
// ./src/api/models/TextSimilarity.ts